<script setup lang="ts">
/**
 * Anything the router cannot resolve, and the two refusals the API returns for a known path:
 * not found and not allowed. One page, the reason in words, one way forward — drawn by the
 * same panel the error handler and the entity pages use, so the portal has one 404.
 */
import RefusalPanel from '~/components/ui/RefusalPanel.vue'

definePageMeta({ layout: 'auth', layoutProps: { showcase: false } })

const route = useRoute()
/** The API answers 404 or 403; the router itself only ever means 404. */
const kind = computed(() => (route.query.reason === 'forbidden' ? 'forbidden' : 'missing'))
</script>

<template>
  <RefusalPanel :kind="kind" />
</template>
